import { render, staticRenderFns } from "./topImg.vue?vue&type=template&id=e2b6c196&scoped=true&"
import script from "./topImg.vue?vue&type=script&lang=js&"
export * from "./topImg.vue?vue&type=script&lang=js&"
import style0 from "./topImg.vue?vue&type=style&index=0&id=e2b6c196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b6c196",
  null
  
)

export default component.exports